<img [src]="path" [alt]="alt" alt="" [class]="cssClass" [ngStyle]="cssStyles"/>
